import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {TheCrypt} from "../../TheCrypt";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";


export class UpgradeCollectorPresentation implements SimplePresentation {
    name: string = "UpgradeCollectorPresentation";

    constructor() {
    }

    shouldRun(): boolean {
        const hasToUpgradeMeter:boolean = (TheCrypt.model.data.addedNumberOfFreespinsThisSpin === 2 || TheCrypt.collectors.fullyChargedM1Collector);
        return !TheCrypt.model.isRestore && hasToUpgradeMeter;
    }

    start(controller: SimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = gsap.timeline({onComplete: () => controller.finish()});
        tl.add(() => controller.setSkipCallback(() => {
            tl.timeScale(3);
        }));
        tl.add(TheCrypt.collectors.showFullFilledCollectorAnimation());
        tl.to(this, {duration: 0.01});

        if (TheCrypt.apiPlugin.settings.get(APISetting.FAST_SPIN)) {
            tl.timeScale(1.4);
        }
    }
}